module.exports = __webpack_public_path__ + "static/tauron-logo.0a160fda.svg";